import React from "react";
import './VendorCategories.css';

import { Category, PageTitle } from "../../../components"; // Component for section heading
import { vendors } from "../../../constants";



const Categories = () => {

  /**
   * Function to get the most popular vendor categories.
   * @param {Array} vendors - The array of vendor objects.
   * @returns {Array} - An array of top 6 vendor categories with count, image, and index.
   */
  const getVendorCategories = (vendors) => {

    const categoryCount = {}; // Object to store how many vendors are in each category
    const categoryImage = {}; // Object to store a representative image for each category

    // Loop through each vendor to count categories and store one image per category
    vendors.forEach((vendor) => {
      const category = vendor.details.category;
      categoryCount[category] = (categoryCount[category] || 0) + 1; // Increment count for the category
      if (!categoryImage[category]) categoryImage[category] = vendor.image; // If no image is stored for this category yet, use the current vendor's image
    });

    // Convert the category count object to an array, sort it by count in descending order,
    // and return an array of formatted category objects
    return Object.entries(categoryCount)
      .sort((a, b) => b[1] - a[1])
      .map(([category, count], index) => ({
        index: index + 1,
        category,
        count,
        image: categoryImage[category],
      }));
  };

  // Get the processed vendor categories
  const categories = getVendorCategories(vendors);

  return (

    <>

      {/* Page Title Section */}
      <PageTitle title={'Vendors Categories'} page={'Vendors Categories'} />

      <section className="vendor-categories">

        {/* Map through each vendor category and render a Category component */}
        <div className="box-container">
          {categories.map(({ index, category, count, image }) => (
            <Category
              key={index}
              index={index}
              category={category}
              count={count}
              image={image}
            />
          ))}
        </div>

      </section>

    </>

  );
};

export default Categories;